module.exports = __webpack_public_path__ + "img/1723614724344-WhatsApp Image 2024-08-14 at 13.45.27.jpeg.dea7af2b.webp";